import Axios from "axios";

// cooldown-action
;(({ $, $$ }) => {
    const disabledClass = 'js-disabled'

    $$('.cooldown-action').forEach(cd => {
        const url = cd.dataset.cooldownUrl
        const emailEl = cd.querySelector('.cooldown-action__email')
        const timeout = cd.dataset.cooldownTimeout ? cd.dataset.cooldownTimeout * 1000 : 60 * 1000

        let email = null

        const trigger = cd.querySelector('.cooldown-action__trigger')
        const counter = cd.querySelector('.cooldown-action__counter')
        const cooldownSection = cd.querySelector('.cooldown-action__cooldown-section')

        let timer = null
        let bTimerActive = false
        let cooldown = timeout / 1000
        let bIsLoading = false

        // console.log(url, email, trigger, counter, timeout, cooldownSection)

        if (!url || !trigger || !counter || !cooldownSection) {
            return
        }

        hideCounter()

        trigger.addEventListener('click', async e => {
            e.preventDefault()

            email = emailEl?.innerHTML.trim()

            if (bTimerActive || bIsLoading) {
                return
            }

            if (await makeRequest()) {
                startCooldown()
            }

        })

        async function makeRequest() {
            try {
                const result = await Axios.post(url, { email })
                // console.log(result)
                return result.data.success
            } catch (err) {
                // console.log(err.response)
                return false
            } finally {
                bIsLoading = false
            }
        }

        function startCooldown() {
            bTimerActive = true

            cooldown = timeout / 1000
            showCounter()
            disableTrigger()

            timer = setInterval(() => {
                if (--cooldown > 0) {
                    updateCounter()
                } else {
                    clearInterval(timer)
                    bTimerActive = false
                    hideCounter()
                    enableTrigger()

                }
            }, 1000)
        }

        function disableTrigger() {
            trigger.classList.add(disabledClass)
        }

        function enableTrigger() {
            trigger.classList.remove(disabledClass)
        }

        function updateCounter() {
            counter.innerText = cooldown
        }

        function showCounter() {
            updateCounter()
            cooldownSection.classList.remove(disabledClass)
        }

        function hideCounter() {
            cooldownSection.classList.add(disabledClass)
        }
    })
})(CNS);